import { ExportOutlined, UserOutlined } from '@ant-design/icons'
import { Button, Select, Space } from 'antd'
import React, { useEffect } from 'react'
import { useMyContext } from '../context/context'
import useHistoryCustom from '../hooks/useHistoryCustom'
import useLanguagesV2 from '../hooks/useLanguagesV2'
import useSettingsV2 from '../hooks/useSettingsV2'
import useTranslations from '../hooks/useTranslations'

const initBurger = () => {
  const $navbarBurgers = Array.prototype.slice.call(document.querySelectorAll('.navbar-burger'), 0)
  if ($navbarBurgers.length > 0) {
    $navbarBurgers.forEach(el => {
      el.addEventListener('click', () => {
        const { target } = el.dataset
        const $target = document.getElementById(target)
        if (!$target) return
        el.classList.toggle('is-active')
        $target.classList.toggle('is-active')
      })
    })
  }
}

const NavBar = () => {
  const { user, logout } = useMyContext()
  const history = useHistoryCustom()
  const { settings } = useSettingsV2()
  const { t } = useTranslations()
  const { languages, languageId, updateLanguageId } = useLanguagesV2()

  useEffect(() => {
    initBurger()
  }, [])

  return (
    <nav
      className="navbar is-primary"
      role="navigation"
      aria-label="main navigation"
      style={{ backgroundColor: settings?.FO_NAVBAR_BACKGROUND_COLOR }}
    >
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <div>
          {user && (
            <div style={{ color: settings?.FO_MEETING_CONNECT_FROM_COLOR || 'black' }} className="navbar-item is-size-6">
              <span style={{ marginRight: 5 }}>{t('WELCOME')}</span>
              <strong>
                {user.firstName} {user.lastName}
              </strong>
            </div>
          )}
        </div>

        <div role="button" className="navbar-burger burger" aria-label="menu" aria-expanded="false" data-target="navbarBasicExample">
          <span aria-hidden="true" />
          <span aria-hidden="true" />
          <span aria-hidden="true" />
        </div>
      </div>

      <div id="navbarBasicExample" className="navbar-menu" style={{ backgroundColor: settings?.FO_NAVBAR_BACKGROUND_COLOR }}>
        {/* <div className="navbar-start">
          {user && (
            <div style={{ color: settings?.FO_MEETING_CONNECT_FROM_COLOR || 'black' }} className="navbar-item is-size-6">
              <span style={{ marginRight: 5 }}>{t('WELCOME')}</span>
              <strong>
                {user.firstName} {user.lastName}
              </strong>
            </div>
          )}
        </div> */}

        <div className="navbar-end">
          <div className="navbar-item">
            <Space>
              {user && (
                <Button type="primary" onClick={() => history.push('')}>
                  {t('HOME')} <UserOutlined />
                </Button>
              )}
              {languages?.length >= 2 ? (
                <Select
                  value={languageId}
                  onChange={async newLanguageId => {
                    updateLanguageId(newLanguageId)
                    // localStorage.setItem('languageId', newLanguageId)
                    // setLanguageId(newLanguageId)
                    // await update({ ...myContext, user: { languageId: newLanguageId } })
                    //   .unwrap()
                    //   .catch(() => {
                    //     window.location.reload()
                    //   })
                  }}
                  options={languages?.map(m => ({ label: m.label, value: m.id }))}
                />
              ) : null}
              {user && (
                <Button onClick={() => logout(() => history.push('/login'))}>
                  {t('LOGOUT')} <ExportOutlined />
                </Button>
              )}
            </Space>
          </div>
        </div>
      </div>
    </nav>
  )
}

export default NavBar
